import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("epc_token");
    if (!token) {
      setUser(false);
      setChecking(false);
      return;
    }
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password, turnstileToken) => {
    const { data } = await api.post("/auth/login", { email, password, "cf-turnstile-response": turnstileToken || undefined });
    if (data.mfa_token) return data; // MFA challenge or forced setup — finish in LoginPage
    localStorage.setItem("epc_token", data.token);
    setUser(data.user);
    return data;
  };

  const completeSession = (data) => {
    localStorage.setItem("epc_token", data.token);
    setUser(data.user);
  };

  const setUserAfterLogin = (u) => {
    setUser(u);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* swallow */ }
    localStorage.removeItem("epc_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout, refreshMe, setUserAfterLogin, completeSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
